import { HEADER_LOGO } from '@src/helpers/imagesConstants'
import { Image } from 'antd'
import React from 'react'

type Props = {}

const LoginHeaderImage = (props: Props) => {
  return (
    <div className="centered-container">
        <Image
      src={HEADER_LOGO}
      preview={false}
    />
    </div>
  )
}

export default LoginHeaderImage